import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Users, FileText, DollarSign, ArrowLeft, Zap } from "lucide-react";

const AdminDashboard_v2 = () => {
  const navigate = useNavigate();

  const adminSections = [
    {
      title: "Members",
      description: "View all members, their tiers, and total advanced amounts",
      icon: Users,
      path: "/admin/members",
      color: "bg-blue-500"
    },
    {
      title: "Help Requests",
      description: "Review, approve, or decline member help requests",
      icon: FileText,
      path: "/admin/requests",
      color: "bg-purple-500"
    },
    {
      title: "Covers & Repayments",
      description: "Track approved covers and manage repayments",
      icon: DollarSign,
      path: "/admin/covers",
      color: "bg-emerald-500"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 py-12 px-6">
      {/* Header */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-xl border-b border-white/10">
        <div className="container mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Zap className="h-8 w-8 text-yellow-400" />
            <span className="text-2xl font-heading font-bold text-white">DueDay</span>
          </div>
          <span className="px-4 py-2 bg-yellow-400/20 border border-yellow-400/50 rounded-full text-yellow-400 text-sm font-semibold">
            Admin Panel
          </span>
        </div>
      </nav>

      <div className="container mx-auto max-w-6xl pt-16">
        <Button 
          data-testid="back-to-dashboard-btn"
          variant="ghost" 
          onClick={() => navigate('/dashboard')}
          className="mb-6 rounded-full text-white hover:text-yellow-400 hover:bg-white/10"
        >
          <ArrowLeft className="mr-2 h-4 w-4" /> Back to Dashboard
        </Button>

        <div className="bg-slate-800/50 border border-slate-700 rounded-2xl p-8 md:p-12">
          <h1 className="text-4xl font-heading font-bold mb-2 text-white" data-testid="admin-dashboard-title">
            Admin Dashboard
          </h1>
          <p className="text-slate-400 mb-12">
            Manage members, review requests, and track repayments
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {adminSections.map((section) => (
              <button
                key={section.path}
                data-testid={`admin-${section.title.toLowerCase().replace(/\s+/g, '-')}-btn`}
                onClick={() => navigate(section.path)}
                className="text-left p-8 rounded-2xl border-2 border-slate-700 hover:border-yellow-400/50 transition-all bg-slate-900/50 hover:bg-slate-900 group"
              >
                <div className={`${section.color} w-14 h-14 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <section.icon className="h-7 w-7 text-white" />
                </div>
                <h3 className="text-2xl font-heading font-bold mb-2 text-white">{section.title}</h3>
                <p className="text-slate-400">{section.description}</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard_v2;
